import React from "react";
import { formatCurrency, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";

export const PublicInvoiceObjectAmount = ({ currency, total, showCurrency, trimDecimals, format }) => {
  const value = formatCurrency(
    total,
    currency.thousand_separator,
    currency.decimal_separator,
    trimDecimals,
    currency.decimal_spaces,
    format
  );
  if (!showCurrency) {
    return value;
  }

  const tooltipValue = formatCurrency(
    total,
    currency.thousand_separator,
    currency.decimal_separator,
    false,
    currency.decimal_spaces,
    "long",
    currency.code
  );

  return (
    <Tooltip title={tooltipValue}>
      <span>
        {value} {currency?.code?.toUpperCase()}
      </span>
    </Tooltip>
  );
};

PublicInvoiceObjectAmount.propTypes = {
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currency: PropTypes.object.isRequired,
  showCurrency: PropTypes.bool,
  trimDecimals: PropTypes.bool,
  format: PropTypes.oneOf(["short", "long"]),
};

PublicInvoiceObjectAmount.defaultProps = {
  showCurrency: true,
  total: 0,
  trimDecimals: true,
  format: "short",
};
